import React, { useId } from 'react';

export const LoginFooterSvg: React.FC = () => {
  const gradId = useId().replace(/:/g, '');

  return (
    <svg
      className="pointer-events-none absolute bottom-0 left-0 right-0 z-[1] h-40 sm:h-52 text-emerald-600"
      viewBox="0 0 1200 140"
      preserveAspectRatio="none"
      aria-hidden
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="currentColor" stopOpacity="0.14" />
          <stop offset="55%" stopColor="currentColor" stopOpacity="0.06" />
          <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path
        className="login-footer-orbit"
        pathLength={100}
        d="M 72 118 A 600 600 0 0 0 1128 118"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.35}
        strokeLinecap="round"
      />
      <path
        className="login-footer-mountain-fill"
        pathLength={100}
        d="M0 140 L0 118 C 210 8 450 108 615 28 S 1015 88 1200 72 L 1200 140 Z"
        fill={`url(#${gradId})`}
      />
      <path
        className="login-footer-range"
        pathLength={100}
        d="M0 118 C 210 8 450 108 615 28 S 1015 88 1200 72"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.65}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="login-footer-range-far"
        pathLength={100}
        d="M0 122 C 240 38 420 98 600 52 S 980 102 1200 78"
        fill="none"
        stroke="currentColor"
        strokeWidth={1}
        strokeLinecap="round"
        opacity={0.45}
      />
    </svg>
  );
};
